<p>existing-loans works!</p>
